module.exports = __webpack_public_path__ + "static/toyota-51b295742aa1b709dbbfcdebe68c14e9.png";